import React from 'react';
import { Alert, Button, Input, Label } from '@appfolio/react-gears';
var defaultNonPrimitiveProps = {
  submitHandler: function submitHandler() {},
  setText: function setText() {}
};

var MessageBox = function MessageBox(_ref) {
  var _ref$showError = _ref.showError,
      showError = _ref$showError === void 0 ? false : _ref$showError,
      _ref$submitHandler = _ref.submitHandler,
      submitHandler = _ref$submitHandler === void 0 ? defaultNonPrimitiveProps.submitHandler : _ref$submitHandler,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      _ref$setText = _ref.setText,
      setText = _ref$setText === void 0 ? defaultNonPrimitiveProps.setText : _ref$setText,
      _ref$placeholderText = _ref.placeholderText,
      placeholderText = _ref$placeholderText === void 0 ? 'Enter message' : _ref$placeholderText,
      _ref$ButtonComponent = _ref.ButtonComponent,
      ButtonComponent = _ref$ButtonComponent === void 0 ? Button : _ref$ButtonComponent,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? 'Send' : _ref$buttonText,
      maxLength = _ref.maxLength,
      _ref$showCharLimit = _ref.showCharLimit,
      showCharLimit = _ref$showCharLimit === void 0 ? false : _ref$showCharLimit;
  var textLength = text.replace(/\r?\n/g, '-').length;
  var textIsValid = text && text.trim();
  return /*#__PURE__*/React.createElement("div", {
    className: "py-3"
  }, /*#__PURE__*/React.createElement(Alert, {
    color: "danger",
    icon: true,
    isOpen: showError
  }, "Message failed to send. Please Retry"), /*#__PURE__*/React.createElement(Label, {
    for: "chat-message",
    className: "sr-only"
  }, "Enter message"), /*#__PURE__*/React.createElement(Input, {
    id: "chat-message",
    placeholder: placeholderText,
    type: "textarea",
    value: text,
    style: {
      resize: 'none'
    },
    onChange: function onChange(e) {
      return setText(e.target.value);
    },
    maxLength: maxLength
  }), /*#__PURE__*/React.createElement("div", {
    className: "py-3"
  }, /*#__PURE__*/React.createElement(ButtonComponent, {
    color: "primary",
    disabled: disabled || !textIsValid,
    onClick: submitHandler
  }, buttonText), showCharLimit && maxLength && /*#__PURE__*/React.createElement("p", {
    className: "float-end js-character-count",
    "data-testid": "character-count",
    style: {
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "js-inline-texting-charater-count"
  }, textLength), "/", maxLength, ' ', "characters")));
};

export default MessageBox;